var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.95C5.00948 0.95 0.95 5.00948 0.95 10C0.95 14.9905 5.00948 19.05 10 19.05C14.9905 19.05 19.05 14.9898 19.05 10C19.05 5.01019 14.9905 0.95 10 0.95ZM10 17.5557C5.83435 17.5557 2.44426 14.1663 2.44426 10C2.44426 5.83365 5.83435 2.44426 10 2.44426C14.1657 2.44426 17.5557 5.83365 17.5557 10C17.5557 14.1664 14.1664 17.5557 10 17.5557Z",
    fill: "#00C853",
    stroke: "#00C853",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4849 9.18958H10.7464V6.45105C10.7464 6.03865 10.4124 5.70391 9.99923 5.70391C9.58606 5.70391 9.25208 6.03865 9.25208 6.45105V9.18958H6.51355C6.10038 9.18958 5.76641 9.52432 5.76641 9.93673C5.76641 10.3491 6.10038 10.6839 6.51355 10.6839H9.25208V13.4224C9.25208 13.8348 9.58606 14.1695 9.99923 14.1695C10.4124 14.1695 10.7464 13.8348 10.7464 13.4224V10.6839H13.4849C13.8981 10.6839 14.232 10.3491 14.232 9.93673C14.232 9.52432 13.8981 9.18958 13.4849 9.18958Z",
    fill: "#00C853",
    stroke: "#00C853",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/PlusGreen.b5a1e75b375116cd2b5a07348e1b0beb.svg";
export { ForwardRef as ReactComponent };